export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "formLabel": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Username"])},
          "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password"])},
          "applicationName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Application name"])},
          "placeholderApplication": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Choose"])},
          "accountName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Account name"])},
          "advancedOptions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Advanced options "])},
          "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" (optional)"])},
          "queueType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Queue type"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Refer to the documentation to learn the difference between SmartQueue and ACDv1"])},
          "typeList": {
            "SmartQueue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SmartQueue"])},
            "ACD": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACDv1"])},
            "None": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["None"])}
          },
          "node": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Node"])}
        },
        "checkbox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Remember me"])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sign in"])},
        "authErrorList": {
          "userName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Username must be at least 3 symbols long"])},
          "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Password must be at least 6 characters long"])},
          "applicationName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please choose an option, it is required field"])},
          "accountName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please fill in the field, it is required"])},
          "empty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Please fill in the field, it is required"])},
          "404": {
            "userName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incorrect user name"])},
            "accountName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incorrect account name"])},
            "applicationName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incorrect application name"])}
          },
          "401": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Incorrect password"])}
        }
      },
      "ru": {
        "formLabel": {
          "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя пользователя"])},
          "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пароль"])},
          "applicationName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Приложение"])},
          "placeholderApplication": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Выбрать"])},
          "accountName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя аккаунта"])},
          "advancedOptions": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Расширенные настройки "])},
          "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize([" (опционально)"])},
          "queueType": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Тип очереди"])},
          "tooltip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["О разнице между SmartQueue и ACDv1 читайте в документации"])},
          "typeList": {
            "SmartQueue": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["SmartQueue"])},
            "ACD": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ACDv1"])},
            "None": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет"])}
          },
          "node": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Node"])}
        },
        "checkbox": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Запомнить"])},
        "button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Войти"])},
        "authErrorList": {
          "userName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Имя пользователя должно быть не менее 3 символов"])},
          "password": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Длина пароля должна быть не менее 6 символов"])},
          "applicationName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обязательное поле"])},
          "accountName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обязательное поле"])},
          "empty": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Обязательное поле"])},
          "404": {
            "userName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неверное имя пользователя"])},
            "accountName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неверное имя аккаунта"])},
            "applicationName": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неверное имя приложения"])}
          },
          "401": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Неверный пароль"])}
        }
      }
    }
  })
}
